import React, { useState, useEffect, useReducer } from "react";
import { useNavigate } from "react-router-dom";

// Layout
import MainLayout from "Layouts/Main";

// styles
import "./styles.scss";

// assets
import assets from "../../../../Assets";

// utils
import { validateInput } from "Services/Utils/validateInput";
// import { notifySuccess } from "Services/Utils/toastNotification";

// Custom Components
import InputBox from "Components/InputBox";
import Button from "Components/Button";
import DropDownBox from "Components/Common/DropDownBox";
import ErrorMessage from "Components/ErrorMessage";
import SuccessCard from "Components/Common/SuccessCard";
import MultiSelectWithCreate from "Components/MultiSelect";
import TextArea from "Components/TextArea";

// redux
import { useDispatch } from "react-redux";
import { addProductTraining, fetchProductTrainingCategory, fetchProductTrainingSubCategory } from "../../../../Redux/Slices/contentManagementSlice";
import { uploadMultiple, uploadSingle } from "../../../../Redux/Slices/mainSlice";
import { addProduct, fetchProductCatalogCategory, fetchProductCatalogSubCategory, fetchProductCatalogType } from "../../../../Redux/Slices/productCatalogSlice";
import { notifyError } from "Services/Utils/toastNotification";

const initialState = {
  designation: '',
  suffix: '',
  performance_class: '',
  radial_internal_clearance: '',
  features: '',
  bearing_type: '',
  bore_size: '',
  outside_diameter: '',
  outside_ring_width: '',
  radius_rs_min: '',
  dynamic_load_rating: '',
  static_load_rating: '',
  reference_speed: '',
  limiting_speed: '',
  mass_kg: '',
};

const formReducer = (state, action) => {
  switch (action.type) {
    case 'SET_FIELD':
      return {
        ...state,
        [action.field]: action.value
      }
    case 'RESET':
      return initialState;
    default:
      return state
  }
}

const AddProductCatalog = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(null);
  const [selectedType, setSetType] = useState(null);
  const [fileCad, setFileCad] = useState("");
  const [multiFile, setMultiFile] = useState([]);
  const [productName, setProductName] = useState("");
  const [productBrand, setProductBrand] = useState("")
  const [productSubBrand, setProductSubBrand] = useState("")
  const [baldwin, setBaldwin] = useState("")
  const [fleetguard, setFleetguard] = useState("")
  const [hifi, setHifi] = useState("")
  const [sakura, setSakura] = useState("")
  const [donaldson, setDonaldson] = useState("")
  const [hengst, sethengst] = useState("")
  const [wix, setWix] = useState("")
  const [mann, setMann] = useState("")
  const [category_id, setCategoryId] = useState(0)
  const [gearboxTorqueRange, setGearboxTorqueRange] = useState("");
  const [gearboxRatios, setGearboxRatios] = useState("");
  const [gearboxMechanicalRating, setGearboxMechanicalRating] = useState("");
  const [gearboxSizes, setGearboxSizes] = useState([]);
  const [gearboxInput, setGearboxInput] = useState("");
  const [gearboxOutput, setGearboxOutput] = useState("");

  const [maxViscosity, setMaxViscosity] = useState("")
  const [mountingConnection, setMountingConnection] = useState("")
  const [housingOption, setHousingOption] = useState("")
  const [productOptions, setProductOptions] = useState("")
  const [description, setDescription] = useState("")
  const [maxFlowrate, setMaxFlowRate] = useState("")
  const [workingPressure, setWorkingPressure] = useState("")
  const [ratedStaticburst, setRatedStaticBurst] = useState("")

  const [isSuccess, setIsSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const [category, setCategory] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [type, setType] = useState([]);
  const [state, formDispatch] = useReducer(formReducer, initialState)

  const dropDownStyles = {
    control: (provided) => ({
      ...provided,
      border: "1px solid #B2BEC3",
      boxShadow: "none",
      padding: "5px 3px",
      fontFamily: "Poppins",
      fontSize: "2.2vh",
      marginRight: "10px",
      height: "7vh",
    }),
    menu: (provided) => ({
      ...provided,
      color: "#697077",
    }),
    option: (provided) => ({
      ...provided,
      color: "#697077",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "black",
    }),
    indicatorSeparator: () => ({ display: "none" }),
  };

  const inputBoxStyles = {
    boxShadow: "none",
    border: "1px solid #B2BEC3",
    padding: "1px 2vh 1px 2vh",
    height: "7vh",
    fontSize: "2.2vh",
    color: "black",
  };

  const inputBoxDesStyles = {
    boxShadow: "none",
    border: "1px solid #B2BEC3",
    padding: "1px 5vh 1px 2vh",
    height: "17vh",
    fontSize: "2.2vh",
    color: "black",
  };

  const handleDropDownChange = (selectedOption) => {
    setSelectedCategory(selectedOption);
    setCategoryId(selectedOption.category_id)
    setErrors({
      ...errors,
      category: ''
    })
    const selectedCategory = category.find(
      (item) => item.category_id === selectedOption.value
    );
    if (selectedCategory) {
      const categoryId = selectedCategory.category_id;
      const getSubCategoryCB = (value) => {
        console.log(value)
        if (value.data.length !== 0) {
          const updatedSubCategories = value.data.map((item) => ({
            ...item,
            label: item.sub_category_name,
            value: item.sub_category_id,
          }));
          setSubCategory(updatedSubCategories);
        } else {
          setSubCategory([]);
        }
      };
      dispatch(
        fetchProductCatalogSubCategory({
          data: categoryId,
          callBack: getSubCategoryCB,
        })
      );
    }
  };

  const handleFileChange = (event) => {
    console.log(event.target.files);
    const formData = new FormData();
    formData.append("file", event.target.files[0]);
    const uploadCB = (value) => {
      setFileCad(value.data.url);
      event.target.value = null; // Clear the previous file value
    };

    dispatch(
      uploadSingle({
        data: formData,
        callBack: uploadCB,
      })
    );
  };

  const handleMultipleFileChange = (event) => {
    // const selectedFiles = event.target.files;
    // console.log(selectedFiles);  
    const files = event.target.files;
    const formData = new FormData();
    Array.from(files).forEach((file) => {
      formData.append("files", file);
    });

    const uploadCB = (value) => {
      // Handle the response, e.g., save URLs of uploaded files
      const uploadedFiles = value.data;
      console.log("Uploaded files:", uploadedFiles);
      const formatChangedArray = uploadedFiles.map((item) => {
        return (
          {
            "product_catalog_images": item.url
          }
        )
      })
      console.log(formatChangedArray)
      setMultiFile((prevMultiFile) => [...prevMultiFile, ...formatChangedArray])
      setErrors({
        ...errors,
        multipleUpload: ''
      })
    };

    dispatch(
      uploadMultiple({
        data: formData,
        callBack: uploadCB,
      })
    );
  };

  const handleValidation = () => {
    let validationErrors = {};

    // if (Number(category_id) === 4) {
    //     const productNameValidation = validateInput("productName", productName);
    //     if (productNameValidation.productName) {
    //       validationErrors.productName = productNameValidation.productName;
    //     }

    //     const torqueRangeValidation = validateInput("gearboxTorqueRange", gearboxTorqueRange);
    //     if (torqueRangeValidation.gearboxTorqueRange) {
    //       validationErrors.gearboxTorqueRange = torqueRangeValidation.gearboxTorqueRange;
    //     }

    //     const ratiosValidation = validateInput("gearboxRatios", gearboxRatios);
    //     if (ratiosValidation.gearboxRatios) {
    //       validationErrors.gearboxRatios = ratiosValidation.gearboxRatios;
    //     }

    //     const mechanicalRatingValidation = validateInput("gearboxMechanicalRating", gearboxMechanicalRating);
    //     if (mechanicalRatingValidation.gearboxMechanicalRating) {
    //       validationErrors.gearboxMechanicalRating = mechanicalRatingValidation.gearboxMechanicalRating;
    //     }

    //     const inputValidation = validateInput("gearboxInput", gearboxInput);
    //     if (inputValidation.gearboxInput) {
    //       validationErrors.gearboxInput = inputValidation.gearboxInput;
    //     }

    //     const outputValidation = validateInput("gearboxOutput", gearboxOutput);
    //     if (outputValidation.gearboxOutput) {
    //       validationErrors.gearboxOutput = outputValidation.gearboxOutput;
    //     }

    //     const gearboxSizesValidation = validateInput("gearboxSizes", gearboxSizes);
    //     if (gearboxSizesValidation.gearboxSizes) {
    //       validationErrors.gearboxSizes = gearboxSizesValidation.gearboxSizes;
    //     }

    //   } 

    if (Number(category_id) !== 4 && Number(category_id) !== 1) {

      const productLearningType = validateInput("selectedType", selectedType);
      if (productLearningType.selectedType) {
        validationErrors.selectedType = productLearningType.selectedType;
      }

      // Add validation for these fields only if selectedType?.value !== 1 (not filtration)
      if (selectedType?.value === 2) {

        //   const validateMaxFlowrate = validateInput("maxFlowrate", maxFlowrate);
        //   if (validateMaxFlowrate.maxFlowrate) {
        //     validationErrors.maxFlowrate = validateMaxFlowrate.maxFlowrate;
        //   }

        //   const validateWorkingPressure = validateInput("workingPressure", workingPressure);
        //   if (validateWorkingPressure.workingPressure) {
        //     validationErrors.workingPressure = validateWorkingPressure.workingPressure;
        //   }

        //   const validateRatedStaticburst = validateInput("ratedStaticburst", ratedStaticburst);
        //   if (validateRatedStaticburst.ratedStaticburst) {
        //     validationErrors.ratedStaticburst = validateRatedStaticburst.ratedStaticburst;
        //   }

        //   const validateMaxViscosity = validateInput("maxViscosity", maxViscosity);
        //   if (validateMaxViscosity.maxViscosity) {
        //     validationErrors.maxViscosity = validateMaxViscosity.maxViscosity;
        //   }

        //   const validateMountingConnection = validateInput("mountingConnection", mountingConnection);
        //   if (validateMountingConnection.mountingConnection) {
        //     validationErrors.mountingConnection = validateMountingConnection.mountingConnection;
        //   }

        //   const validateHousingOption = validateInput("housingOption", housingOption);
        //   if (validateHousingOption.housingOption) {
        //     validationErrors.housingOption = validateHousingOption.housingOption;
        //   }

        //   const validateProductOptions = validateInput("productOptions", productOptions);
        //   if (validateProductOptions.productOptions) {
        //     validationErrors.productOptions = validateProductOptions.productOptions;
        //   }


        //   const validateDescription = validateInput("description", description);
        //   if (validateDescription.description) {
        //     validationErrors.description = validateDescription.description;
        //   }
      } else {
        // for filteration type

        //   const validateHifi = validateInput("hifi", hifi);
        //     if (validateHifi.hifi) {
        //       validationErrors.hifi = validateHifi.hifi;
        //     }
        //     const validateSakura = validateInput("sakura", sakura);
        //     if (validateSakura.sakura) {
        //       validationErrors.sakura = validateSakura.sakura;
        //     }
        //     const validateDonaldson = validateInput("donaldson", donaldson);
        //     if (validateDonaldson.donaldson) {
        //       validationErrors.donaldson = validateDonaldson.donaldson;
        //     }
        //     const validateHengst = validateInput("hengst", hengst);
        //     if (validateHengst.hengst) {
        //       validationErrors.hengst = validateHengst.hengst;
        //     }
        //     const validateWix = validateInput("wix", wix);
        //     if (validateWix.wix) {
        //       validationErrors.wix = validateWix.wix;
        //     }
        //     const validateMann = validateInput("mann", mann);
        //     if (validateMann.mann) {
        //       validationErrors.mann = validateMann.mann;
        //     }

        //   const validateBaldwin = validateInput("baldwin", baldwin);
        //   if (validateBaldwin.baldwin) {
        //     validationErrors.baldwin = validateBaldwin.baldwin;
        //   }
        //   const validateFleetguard = validateInput("fleetguard", fleetguard);
        //   if (validateFleetguard.fleetguard) {
        //     validationErrors.fleetguard = validateFleetguard.fleetguard;
        //   }
        const productSubCategory = validateInput("sub_category", selectedSubCategory);
        if (productSubCategory.sub_category) {
          validationErrors.sub_category = productSubCategory.sub_category;
        }
      }
    }

    const productCategory = validateInput("category", selectedCategory);
    if (productCategory.category) {
      validationErrors.category = productCategory.category;
    }

    const productLearningTitle = validateInput("productName", productName);
    if (productLearningTitle.productName) {
      validationErrors.productName = productLearningTitle.productName;
    }

    setErrors(validationErrors);
    console.log(validationErrors);
    return validationErrors;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const validationErrors = handleValidation();
    if (Object.keys(validationErrors).length === 0) {

      let data = {
        category_id: selectedCategory.category_id,
        category_name: selectedCategory.category_name,
        product_name: productName,
        product_catalog_images: multiFile,
      }

      if (Number(category_id) === 4) {
        // Add Gearbox/Motors specific fields
        data = {
          ...data,
          "gearbox_torque_range": gearboxTorqueRange,
          "gearbox_ratios": gearboxRatios,
          "gearbox_mechanical_rating": gearboxMechanicalRating,
          "gearbox_input": gearboxInput,
          "gearbox_output": gearboxOutput,
          //  "gearbox_sizes": gearboxSizes.length > 0 ? gearboxSizes.join: null
          "gearbox_sizes": gearboxSizes,
        };
      } else if(Number(category_id === 1)) {
        data = {
          ...data,
              designation: state.designation,
              suffix: state.suffix,
              performance_class : state.performance_class,
              radial_internal_clearance_um: state.radial_internal_clearance,
              features: state.features,
              bearing_type: state.bearing_type,
              bore_size_d_mm: state.bore_size,
              outside_diameter_d_mm: state.outside_diameter,
              outside_ring_width_b_mm: state.outside_ring_width,
              radius_rs_min_mm: state.radius_rs_min,
              dynamic_load_rating_cr_n: state.dynamic_load_rating,
              static_load_rating_c0r_n: state.static_load_rating,
              reference_speed_rpm: state.reference_speed,
              limiting_speed_rpm: state.limiting_speed,
              mass_kg: state.mass_kg,

        }
      } 
      else {
        // Add Filteration specific fields
        data = {
          ...data,
          filteration_type_id: selectedType?.value,
          filteration_type_name: selectedType?.label,
          ...(productBrand && { product_brand_name: productBrand }), // Conditionally include `product_brand_name`
          ...(productSubBrand && { product_sub_brand_name: productSubBrand }),
          // Add fields based on filtration type
          ...(selectedType?.value === 1 ? {
            sub_category_id: selectedSubCategory.sub_category_id,
            sub_category_name: selectedSubCategory.sub_category_name,
            baldwin: baldwin,
            fleetguard: fleetguard,
            hifi: hifi,
            sakura: sakura,
            donaldson: donaldson,
            hengst: hengst,
            wix: wix,
            mann: mann,
          } : {
            max_flow_rate: maxFlowrate,
            working_pressure: workingPressure,
            rated_static_burst: ratedStaticburst,
            max_viscosity: maxViscosity,
            mounting_connection: mountingConnection,
            housing_option_available: housingOption === "Yes" ? true : false,
            product_option: productOptions,
            description: description,
          }),
          ...(fileCad && { upload_cad_drawing: fileCad }),
        }
      }

      console.log(data)
      if (data.product_catalog_images.length <= 0) {
        notifyError("Please upload at least one image for the product")
      }
      else {
        const addProductCB = () => {
          setIsSuccess(true);
        };

        dispatch(
          addProduct({
            data: data,
            callBack: addProductCB,
          })
        );
      }
    }
  };

  useEffect(() => {
    dispatch(
      fetchProductCatalogCategory({
        callBack: getCategoryCB,
      })
    );
    dispatch(
      fetchProductCatalogType({
        callBack: getTypeCB
      })
    )
  }, []);

  const getCategoryCB = (value) => {
    console.log(value);
    const updatedCategories = value.data
      .filter(
        (item) =>
          item.category_name !== "Lubrication"
      )
      .map((item) => ({
        ...item,
        label: item.category_name,
        value: item.category_id,
      }));

    setCategory(updatedCategories);
  };


  const getTypeCB = (value) => {
    console.log(value.data)
    const updatedTypes = value.data.map((item) => ({
      ...item,
      label: item?.filteration_type_name,
      value: item?.filteration_type_id
    }));
    setType(updatedTypes)
    console.log(type, "type")
  }

  const handleRemove = (indexToRemove) => {
    setMultiFile((prevMultiFile) =>
      prevMultiFile.map((item, index) => {
        // Check if the current item is at the specified index
        if (index === indexToRemove) {
          // If product_catalog_images_id exists, mark as deleted
          if (item.product_catalog_images_id) {
            return { ...item, isDeleted: true };
          }
          // If no product_catalog_images_id, return null to filter out later
          return null;
        }
        // Leave other items as they are
        return item;
      })
        .filter((item) => item !== null) // Remove items that are set to null
    );
  };

  const handleBearingChange = (e) => {
    const { name, value } = e.target;
    formDispatch({
      type: "SET_FIELD",
      field: name,
      value,
    })
  }

  return (
    <MainLayout pageName={"Product Catalog"}>
      {isSuccess && (
        <SuccessCard
          title="Product Added Successfully"
          subTitle="Product Details Added Successfully."
          onClose={() => setIsSuccess(false)}
          onGoBack={() => navigate(-1)}
        />
      )}
      <div className="goBackDiv" onClick={() => navigate(-1)}>
        <img src={assets.Icons.leftArrow} alt="backIcon" />
        <p>Back to Product Catalog</p>
      </div>
      <form className="AddProductContainer" onSubmit={handleSubmit}>
        <div className="AddProductContainerHeader">
          <h2>Add Product Details</h2>
        </div>
        <hr style={{ border: "1px solid #E6E6E6", marginBottom: "45px" }} />
        <div className="AddProductInputBoxBody">
          {(Number(category_id) !== 4 || Number(category_id) === 2) && Number(category_id) !== 1 && (
            <>
              <div className="AddProductInputContainer">
                <p>Category</p>
                <div className="AddProductInputBoxContainer">
                  <DropDownBox
                    options={category}
                    placeholder="Select Here"
                    onChange={handleDropDownChange}
                    value={selectedCategory}
                    customStyles={dropDownStyles}
                  />
                  {errors.category && (
                    <ErrorMessage message={errors.category} />
                  )}
                </div>
              </div>
              {selectedType?.value === 1
                ?
                <div className="AddProductInputContainer">
                  <p>Sub Category</p>
                  <div className="AddProductInputBoxContainer">
                    <DropDownBox
                      options={subCategory}
                      placeholder="Select Here"
                      onChange={(option) => {
                        setSelectedSubCategory(option);
                        setErrors({
                          ...errors,
                          sub_category: "",
                        });
                      }}
                      value={selectedSubCategory}
                      customStyles={dropDownStyles}
                    />
                    {errors.sub_category && (
                      <ErrorMessage message={errors.sub_category} />
                    )}
                  </div>
                </div> : ""}

              <div className="AddProductInputContainer">
                <p>Type</p>
                <div className="AddProductInputBoxContainer">
                  <DropDownBox
                    options={type.map((item) => ({
                      label: item.filtration_type_name, // Setting the visible text
                      value: item.filtration_type_id, // Setting the unique identifier
                    }))}
                    placeholder="Select Here"
                    onChange={(option) => {
                      setSetType(option);
                      setErrors({
                        ...errors,
                        selectedType: "",
                      });
                    }}
                    value={selectedType}
                    customStyles={dropDownStyles}
                  />
                  {errors.selectedType && (
                    <ErrorMessage message={errors.selectedType} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Product Name</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="learningTitle"
                    value={productName}
                    onChange={(e) => {
                      setProductName(e.target.value);
                      setErrors({
                        ...errors,
                        productName: "",
                      });
                    }}
                  />
                  {errors.productName && (
                    <ErrorMessage message={errors.productName} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Product Brand Name (optional)</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="productBrand"
                    value={productBrand}
                    onChange={(e) => {
                      setProductBrand(e.target.value);
                    }}
                  />
                  {/* {errors.category && <ErrorMessage message={errors.category} />} */}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Product Sub Brand Name (optional)</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="productSubBrand"
                    value={productSubBrand}
                    onChange={(e) => {
                      setProductSubBrand(e.target.value);
                    }}
                  />
                  {/* {errors.productName && <ErrorMessage message={errors.productName} />} */}
                </div>
              </div>
              {/* need to hide baldwin and fleetguard if filter type is not filteration */}
              {selectedType?.value === 1
                ?
                <>
                  <div className="AddProductInputContainer">
                    <p>Baldwin</p>
                    <div className="AddProductInputBoxContainer">
                      <InputBox
                        inputStyle={inputBoxStyles}
                        name="baldwin"
                        value={baldwin}
                        onChange={(e) => {
                          setBaldwin(e.target.value);
                          setErrors({
                            ...errors,
                            baldwin: "",
                          });
                        }}
                      />
                      {errors.baldwin && <ErrorMessage message={errors.baldwin} />}
                    </div>
                  </div>
                  <div className="AddProductInputContainer">
                    <p>Fleetguard</p>
                    <div className="AddProductInputBoxContainer">
                      <InputBox
                        inputStyle={inputBoxStyles}
                        name="fleetguard"
                        value={fleetguard}
                        onChange={(e) => {
                          setFleetguard(e.target.value);
                          setErrors({
                            ...errors,
                            fleetguard: "",
                          });
                        }}
                      />
                      {errors.fleetguard && (
                        <ErrorMessage message={errors.fleetguard} />
                      )}
                    </div>
                  </div>
                  <div className="AddProductInputContainer">
                    <p>Hifi</p>
                    <div className="AddProductInputBoxContainer">
                      <InputBox
                        inputStyle={inputBoxStyles}
                        name="hifi"
                        value={hifi}
                        onChange={(e) => {
                          setHifi(e.target.value);
                          setErrors({
                            ...errors,
                            hifi: "",
                          });
                        }}
                      />
                      {errors.hifi && <ErrorMessage message={errors.hifi} />}
                    </div>
                  </div>
                  <div className="AddProductInputContainer">
                    <p>Sakura</p>
                    <div className="AddProductInputBoxContainer">
                      <InputBox
                        inputStyle={inputBoxStyles}
                        name="sakura"
                        value={sakura}
                        onChange={(e) => {
                          setSakura(e.target.value);
                          setErrors({
                            ...errors,
                            sakura: "",
                          });
                        }}
                      />
                      {errors.sakura && <ErrorMessage message={errors.sakura} />}
                    </div>
                  </div>
                  <div className="AddProductInputContainer">
                    <p>Donaldson</p>
                    <div className="AddProductInputBoxContainer">
                      <InputBox
                        inputStyle={inputBoxStyles}
                        name="donaldson"
                        value={donaldson}
                        onChange={(e) => {
                          setDonaldson(e.target.value);
                          setErrors({
                            ...errors,
                            donaldson: "",
                          });
                        }}
                      />
                      {errors.donaldson && (
                        <ErrorMessage message={errors.donaldson} />
                      )}
                    </div>
                  </div>
                  <div className="AddProductInputContainer">
                    <p>Hengst</p>
                    <div className="AddProductInputBoxContainer">
                      <InputBox
                        inputStyle={inputBoxStyles}
                        name="hengst"
                        value={hengst}
                        onChange={(e) => {
                          sethengst(e.target.value);
                          setErrors({
                            ...errors,
                            hengst: "",
                          });
                        }}
                      />
                      {errors.hengst && <ErrorMessage message={errors.hengst} />}
                    </div>
                  </div>
                  <div className="AddProductInputContainer">
                    <p>WIX</p>
                    <div className="AddProductInputBoxContainer">
                      <InputBox
                        inputStyle={inputBoxStyles}
                        name="wix"
                        value={wix}
                        onChange={(e) => {
                          setWix(e.target.value);
                          setErrors({
                            ...errors,
                            wix: "",
                          });
                        }}
                      />
                      {errors.wix && <ErrorMessage message={errors.wix} />}
                    </div>
                  </div>
                  <div className="AddProductInputContainer">
                    <p>Mann</p>
                    <div className="AddProductInputBoxContainer">
                      <InputBox
                        inputStyle={inputBoxStyles}
                        name="mann"
                        value={mann}
                        onChange={(e) => {
                          setMann(e.target.value);
                          setErrors({
                            ...errors,
                            mann: "",
                          });
                        }}
                      />
                      {errors.mann && <ErrorMessage message={errors.mann} />}
                    </div>
                  </div>
                </> :
                <>

                  <div className="AddProductInputContainer">
                    <p>Max Flow Rate</p>
                    <div className="AddProductInputBoxContainer">
                      <InputBox
                        inputStyle={inputBoxStyles}
                        name="maxFlowRate"
                        value={maxFlowrate}
                        onChange={(e) => {
                          setMaxFlowRate(e.target.value);
                          setErrors({
                            ...errors,
                            maxFlowrate: "",
                          });
                        }}
                      />
                      {errors.maxFlowrate && (
                        <ErrorMessage message={errors.maxFlowrate} />
                      )}
                    </div>
                  </div>
                  <div className="AddProductInputContainer">
                    <p>Working Pressure</p>
                    <div className="AddProductInputBoxContainer">
                      <InputBox
                        inputStyle={inputBoxStyles}
                        name="workingPressure"
                        value={workingPressure}
                        onChange={(e) => {
                          setWorkingPressure(e.target.value);
                          setErrors({
                            ...errors,
                            workingPressure: "",
                          });
                        }}
                      />
                      {errors.workingPressure && (
                        <ErrorMessage message={errors.workingPressure} />
                      )}
                    </div>
                  </div>
                  <div className="AddProductInputContainer">
                    <p>Rated Static Burst</p>
                    <div className="AddProductInputBoxContainer">
                      <InputBox
                        inputStyle={inputBoxStyles}
                        name="ratedStaticBurst"
                        value={ratedStaticburst}
                        onChange={(e) => {
                          setRatedStaticBurst(e.target.value);
                          setErrors({
                            ...errors,
                            ratedStaticburst: "",
                          });
                        }}
                      />
                      {errors.ratedStaticburst && (
                        <ErrorMessage message={errors.ratedStaticburst} />
                      )}
                    </div>
                  </div>

                  <div className="AddProductInputContainer">
                    <p>Max Viscosity</p>
                    <div className="AddProductInputBoxContainer">
                      <InputBox
                        inputStyle={inputBoxStyles}
                        name="maxViscosity"
                        value={maxViscosity}
                        onChange={(e) => {
                          setMaxViscosity(e.target.value);
                          setErrors({
                            ...errors,
                            maxViscosity: "",
                          });
                        }}
                      />
                      {errors.maxViscosity && (
                        <ErrorMessage message={errors.maxViscosity} />
                      )}
                    </div>
                  </div>
                  <div className="AddProductInputContainer">
                    <p>Mounting Connection</p>
                    <div className="AddProductInputBoxContainer">
                      <InputBox
                        inputStyle={inputBoxStyles}
                        name="mountingConnection"
                        value={mountingConnection}
                        onChange={(e) => {
                          setMountingConnection(e.target.value);
                          setErrors({
                            ...errors,
                            mountingConnection: "",
                          });
                        }}
                      />
                      {errors.mountingConnection && (
                        <ErrorMessage message={errors.mountingConnection} />
                      )}
                    </div>
                  </div>
                  <div className="AddProductInputContainer">
                    <p>Housing Option Available</p>
                    <div className="AddProductInputBoxContainer">
                      <DropDownBox
                        options={[
                          { label: "Yes", value: true },
                          { label: "No", value: false },
                        ]}
                        placeholder="Select Here"
                        value={housingOption}
                        onChange={(option) => {
                          setHousingOption(option);
                          setErrors({
                            ...errors,
                            housingOption: "",
                          });
                        }}
                        customStyles={dropDownStyles}
                      />
                      {errors.housingOption && (
                        <ErrorMessage message={errors.housingOption} />
                      )}
                    </div>
                  </div>
                  <div className="AddProductInputContainer">
                    <p>Product Options</p>
                    <div className="AddProductInputBoxContainer">
                      <InputBox
                        inputStyle={inputBoxStyles}
                        name="productOptions"
                        value={productOptions}
                        onChange={(e) => {
                          setProductOptions(e.target.value);
                          setErrors({
                            ...errors,
                            productOptions: "",
                          });
                        }}
                        disabled={true}
                      />
                      {errors.productOptions && (
                        <ErrorMessage message={errors.productOptions} />
                      )}
                    </div>
                  </div>
                  <div className="AddProductInputContainer">
                    <p>Description</p>
                    <div className="AddProductInputBoxContainer">
                      <TextArea
                        inputStyle={inputBoxDesStyles}
                        placeholder="Enter here"
                        name="description"
                        value={description}
                        onChange={(e) => {
                          setDescription(e.target.value);
                          setErrors({
                            ...errors,
                            description: "",
                          });
                        }}
                      />
                      {errors.description && (
                        <ErrorMessage message={errors.description} />
                      )}
                    </div>
                  </div>
                </>
              }

              <div className="AddProductInputContainer">
                <p style={{ marginBottom: "15px" }}>
                  Upload CAD Document (optional)
                </p>
                <div className="fileUploadContainer">
                  <label
                    htmlFor="uploadFile"
                    className="uploadProductFileLabel"
                  >
                    Upload
                    <input
                      type="file"
                      id="uploadFile"
                      accept=".pdf"
                      style={{ display: "none" }}
                      onChange={handleFileChange}
                    />
                  </label>
                </div>
                <p style={{ marginTop: "1rem" }}>
                  {fileCad.split("---").pop()}
                  {fileCad ? (
                    <span
                      style={{
                        color: "red",
                        marginLeft: "10px",
                        fontSize: "16px",
                        cursor: "pointer",
                      }}
                      onClick={() => setFileCad("")}
                    >
                      X
                    </span>
                  ) : (
                    ""
                  )}
                </p>
              </div>
            </>
          )}

          {Number(category_id) === 1 && (
            <>
              <div className="AddProductInputContainer">
                <p>Category</p>
                <div className="AddProductInputBoxContainer">
                  <DropDownBox
                    options={category}
                    placeholder="Bearings"
                    onChange={handleDropDownChange}
                    value={selectedCategory}
                    customStyles={dropDownStyles}
                  />
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Product Name</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="productName"
                    value={productName}
                    onChange={(e) => setProductName(e.target.value)}
                  />
                  {errors.productName && (
                    <ErrorMessage message={errors.productName} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Designation</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="designation"
                    value={state.designation}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.designation && (
                    <ErrorMessage message={errors.designation} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Suffix</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="suffix"
                    value={state.suffix}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.suffix && (
                    <ErrorMessage message={errors.suffix} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Performance Class</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="performance_class"
                    value={state.performance_class}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.performance_class && (
                    <ErrorMessage message={errors.performance_class} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Radial Internal Clearance</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="radial_internal_clearance"
                    value={state.radial_internal_clearance}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.radial_internal_clearance && (
                    <ErrorMessage message={errors.radial_internal_clearance} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Features</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="features"
                    value={state.features}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.features && (
                    <ErrorMessage message={errors.features} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Bearing Type</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="bearing_type"
                    value={state.bearing_type}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.bearing_type && (
                    <ErrorMessage message={errors.bearing_type} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Bore Size(mm)</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="bore_size"
                    value={state.bore_size}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.bore_size && (
                    <ErrorMessage message={errors.bore_size} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Outside Diameter(mm)</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="outside_diameter"
                    value={state.outside_diameter}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.outside_diameter && (
                    <ErrorMessage message={errors.outside_diameter} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Outside Ring Width(mm)</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="outside_ring_width"
                    value={state.outside_ring_width}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.outside_ring_width && (
                    <ErrorMessage message={errors.outside_ring_width} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Radius</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="radius_rs_min"
                    value={state.radius_rs_min}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.radius_rs_min && (
                    <ErrorMessage message={errors.radius_rs_min} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Dynamic Load Rating</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="dynamic_load_rating"
                    value={state.dynamic_load_rating}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.dynamic_load_rating && (
                    <ErrorMessage message={errors.dynamic_load_rating} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Static Load Rating</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="static_load_rating"
                    value={state.static_load_rating}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.static_load_rating && (
                    <ErrorMessage message={errors.static_load_rating} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Reference Speed(rpm)</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="reference_speed"
                    value={state.reference_speed}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.reference_speed && (
                    <ErrorMessage message={errors.reference_speed} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Limiting Speed(rpm)</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="limiting_speed"
                    value={state.limiting_speed}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.limiting_speed && (
                    <ErrorMessage message={errors.limiting_speed} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Mass(kg)</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="mass_kg"
                    value={state.mass_kg}
                    onChange={(e) => handleBearingChange(e)}
                  />
                  {errors.mass_kg && (
                    <ErrorMessage message={errors.mass_kg} />
                  )}
                </div>
              </div>
            </>
          )}
          {Number(category_id) === 4 && (
            <>
              <div className="AddProductInputContainer">
                <p>Category</p>
                <div className="AddProductInputBoxContainer">
                  <DropDownBox
                    options={category}
                    placeholder="Gearbox/Motors"
                    onChange={handleDropDownChange}
                    value={selectedCategory}
                    customStyles={dropDownStyles}
                  />
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Product Name</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="productName"
                    value={productName}
                    onChange={(e) => setProductName(e.target.value)}
                  />
                  {errors.productName && (
                    <ErrorMessage message={errors.productName} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Gearbox Torque Range</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="gearboxTorqueRange"
                    value={gearboxTorqueRange}
                    onChange={(e) => setGearboxTorqueRange(e.target.value)}
                  />
                  {errors.gearboxTorqueRange && (
                    <ErrorMessage message={errors.gearboxTorqueRange} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Gearbox Ratios</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="gearboxRatios"
                    value={gearboxRatios}
                    onChange={(e) => setGearboxRatios(e.target.value)}
                  />
                  {errors.gearboxRatios && (
                    <ErrorMessage message={errors.gearboxRatios} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Gearbox Mechanical Rating</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="gearboxMechanicalRating"
                    value={gearboxMechanicalRating}
                    onChange={(e) => setGearboxMechanicalRating(e.target.value)}
                  />
                  {errors.gearboxMechanicalRating && (
                    <ErrorMessage message={errors.gearboxMechanicalRating} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Gearbox Sizes</p>
                <div className="AddProductInputBoxContainer">
                  <MultiSelectWithCreate
                    initialSelectedSizes={gearboxSizes}
                    onChange={(selectedValues) => {
                      setGearboxSizes(selectedValues);
                    }}
                  />
                  {errors.gearboxSizes && (
                    <ErrorMessage message={errors.gearboxSizes} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Gearbox Input</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="gearboxInput"
                    value={gearboxInput}
                    onChange={(e) => setGearboxInput(e.target.value)}
                  />
                  {errors.gearboxInput && (
                    <ErrorMessage message={errors.gearboxInput} />
                  )}
                </div>
              </div>
              <div className="AddProductInputContainer">
                <p>Gearbox Output</p>
                <div className="AddProductInputBoxContainer">
                  <InputBox
                    inputStyle={inputBoxStyles}
                    name="gearboxOutput"
                    value={gearboxOutput}
                    onChange={(e) => setGearboxOutput(e.target.value)}
                  />
                  {errors.gearboxOutput && (
                    <ErrorMessage message={errors.gearboxOutput} />
                  )}
                </div>
              </div>
            </>
          )}
        </div>
        <p style={{ fontWeight: "700", marginTop: "15px" }}>
          Upload Product Images
        </p>
        <div className="multipleProductImageUpload1">
          <label
            htmlFor="uploadMultipleFile"
            className="uploadProductFileLabel"
          >
            <img src={assets.Icons.uploadIcon} alt="upload Icon" />
            Upload Multiple Files
            <input
              multiple
              type="file"
              id="uploadMultipleFile"
              accept=".jpg,.jpeg,.png,.webp"
              style={{ display: "none" }}
              onChange={handleMultipleFileChange}
            />
          </label>
          <div className="productImagesContainer">
            {multiFile.length > 0
              ? multiFile.map((item, index) => {
                console.log(item);
                return (
                  item.isDeleted !== true && (
                    <div
                      key={index}
                      className="individualProductImageContainer"
                    >
                      <p
                        onClick={() => handleRemove(index)}
                        style={{ cursor: "pointer" }}
                      >
                        X
                      </p>
                      <img src={item.product_catalog_images} alt="product" />
                    </div>
                  )
                );
              })
              : ""}
          </div>
        </div>
        {errors.multipleUpload && (
          <ErrorMessage message={errors.multipleUpload} />
        )}

        <div className="addStaffButtons">
          <div className="addStaffButtonContainer">
            <Button
              buttonStyle={{ height: "2vh", backgroundColor: "#FFFFFF" }}
              titleStlye={{ color: "#888888" }}
              title="Cancel"
              onClick={() => navigate(-1)}
            />
          </div>
          <div className="addStaffButtonContainer">
            <Button
              forForm={true}
              buttonStyle={{ height: "2vh" }}
              title="Save"
            />
          </div>
        </div>
      </form>
    </MainLayout>
  );
};

export default AddProductCatalog;
